import * as types from './types';

export const addPageState = (stateName, pageState) => ({
  type: types.PAGE_STATE_CACHE_ADD_PAGE_STATE,
  payload: { stateName, pageState },
});

export const removePageState = (stateName) => ({
  type: types.PAGE_STATE_CACHE_REMOVE_PAGE_STATE,
  payload: { stateName },
});



// WEBPACK FOOTER //
// ./src/state/pagestatecache/actions.js